import { useState } from 'react';

const testimonials = [
  {
    name: 'Sarah Johnson',
    location: 'Baltimore, MD',
    service: 'Timeshare Exit',
    rating: 5,
    date: '2024-09-15',
    text: 'Acquisitions Portfolio helped me liquidate my timeshare contract that I had been stuck with for years. Their team was professional, transparent, and delivered exactly what they promised. I finally feel free from that financial burden!',
    image: 'https://public.readdy.ai/ai/img_res/15ee00918322daa2bcbf5920091045ec.jpg'
  },
  {
    name: 'Michael Chen',
    location: 'Los Angeles, CA',
    service: 'Resort Resale',
    rating: 5,
    date: '2024-10-03',
    text: 'I was amazed at how quickly they sold my resort property. The market analysis was spot-on, and within just 3 months the deal was closed. The entire process was smooth and completely stress-free.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20businessman%20in%20suit%20with%20confident%20expression%2C%20clean%20white%20background%2C%20corporate%20portrait%20style&width=100&height=100&seq=testimonial2&orientation=squarish'
  },
  {
    name: 'Emily Rodriguez',
    location: 'Phoenix, AZ',
    service: 'Deed Transfer',
    rating: 5,
    date: '2024-11-20',
    text: 'The deed transfer service was exceptional. They handled all the legal paperwork and made sure everything was compliant. I appreciated their attention to detail and constant communication throughout the process.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Hispanic%20woman%20with%20friendly%20smile%2C%20business%20casual%20attire%2C%20clean%20white%20background%2C%20professional%20portrait%20photography&width=100&height=100&seq=testimonial3&orientation=squarish'
  },
  {
    name: 'David Thompson',
    location: 'Plano, TX',
    service: 'Buyback Closing',
    rating: 5,
    date: '2025-01-08',
    text: 'Their buyback closing consultation saved me from making a costly mistake. The team provided valuable insights into market trends and helped me optimize my property portfolio. Highly recommend their expertise!',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20mature%20businessman%20with%20gray%20hair%20and%20warm%20smile%2C%20business%20suit%2C%20clean%20white%20background%2C%20executive%20portrait%20style&width=100&height=100&seq=testimonial4&orientation=squarish'
  },
  {
    name: 'Linda Marsh',
    location: 'Orlando, FL',
    service: 'Timeshare Exit',
    rating: 5,
    date: '2025-02-14',
    text: 'After years of paying maintenance fees on a timeshare I never used, Acquisitions Portfolio got me out in under 90 days. Their buyback closings process was clear and straightforward from start to finish.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20mature%20woman%20with%20short%20blonde%20hair%20and%20warm%20smile%2C%20business%20attire%2C%20clean%20white%20background%2C%20portrait%20photography&width=100&height=100&seq=testimonial5&orientation=squarish'
  },
  {
    name: 'James Okafor',
    location: 'Houston, TX',
    service: 'Buyback Closing',
    rating: 5,
    date: '2025-03-01',
    text: 'The team walked me through every step of the buyback closing process. No hidden fees, no surprises — just results. I would absolutely recommend them to anyone looking to exit their timeshare.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20African%20American%20businessman%20with%20confident%20smile%2C%20business%20suit%2C%20clean%20white%20background%2C%20corporate%20portrait%20photography&width=100&height=100&seq=testimonial6&orientation=squarish'
  }
];

export const TestimonialsSection: React.FC = () => {
  const [expanded, setExpanded] = useState<number | null>(null);

  return (
    <section
      id="testimonials"
      className="py-24 bg-white"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      <meta itemProp="name" content="Client Reviews — Acquisitions Portfolio Developer" />
      <meta itemProp="numberOfItems" content={String(testimonials.length)} />

      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-amber-600 mb-3">
            Verified Client Reviews
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Real results from real clients. Our buyback closings and timeshare exit services have helped hundreds of families across the United States.
          </p>

          {/* Aggregate stars */}
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-xl"></i>
              ))}
            </div>
            <span className="text-gray-800 font-semibold text-lg">4.9</span>
            <span className="text-gray-400 text-sm">/ 5 &nbsp;·&nbsp; 127 reviews</span>
          </div>
        </div>

        {/* Review Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-7 flex flex-col gap-4 shadow-sm hover:shadow-md transition-shadow duration-300"
              itemScope
              itemType="https://schema.org/Review"
              itemProp="itemListElement"
            >
              {/* Hidden schema fields */}
              <meta itemProp="datePublished" content={t.date} />
              <div itemScope itemType="https://schema.org/LocalBusiness" itemProp="itemReviewed">
                <meta itemProp="name" content="Acquisitions Portfolio Developer | Buyback Closings" />
                <meta itemProp="url" content="https://example.com" />
              </div>

              {/* Stars */}
              <div
                itemScope
                itemType="https://schema.org/Rating"
                itemProp="reviewRating"
                className="flex gap-0.5"
              >
                <meta itemProp="ratingValue" content={String(t.rating)} />
                <meta itemProp="bestRating" content="5" />
                <meta itemProp="worstRating" content="1" />
                {[...Array(t.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>

              {/* Review text */}
              <blockquote
                itemProp="reviewBody"
                className="text-gray-700 text-sm leading-relaxed flex-1"
              >
                {expanded === index || t.text.length <= 160
                  ? `"${t.text}"`
                  : `"${t.text.slice(0, 160)}…"`}
                {t.text.length > 160 && (
                  <button
                    onClick={() => setExpanded(expanded === index ? null : index)}
                    className="ml-1 text-amber-600 font-medium text-xs hover:underline cursor-pointer whitespace-nowrap"
                  >
                    {expanded === index ? 'Show less' : 'Read more'}
                  </button>
                )}
              </blockquote>

              {/* Service badge */}
              <span className="inline-block self-start text-xs font-semibold bg-amber-100 text-amber-700 px-3 py-1 rounded-full">
                {t.service}
              </span>

              {/* Author */}
              <div
                className="flex items-center gap-3 pt-2 border-t border-gray-200"
                itemScope
                itemType="https://schema.org/Person"
                itemProp="author"
              >
                <img
                  src={t.image}
                  alt={t.name}
                  title={`${t.name} — ${t.service} client`}
                  className="w-11 h-11 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <p itemProp="name" className="text-sm font-semibold text-gray-900">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-400">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
